import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideRouter, withInMemoryScrolling } from "@angular/router";

import { routes } from "./app.routes";
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { provideAnimations } from "@angular/platform-browser/animations";
import { providePrimeNG } from "primeng/config";
import { provideNgxMask } from "ngx-mask";
import { MyPreset } from "./config/theme";
import { AppInitializerService } from "@services/app-initalizer.service";
import { errorInterceptor } from "@shared/interceptors/error-interceptor";
import { MessageService } from "primeng/api";
import {
  loadingInterceptor,
  tokenInterceptor,
} from "@shared/interceptors/token.interceptor";
import { LookupService } from "@services/lookup.service";
import { TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { provideTranslateService } from "@ngx-translate/core";

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (
  http: HttpClient
) => new TranslateHttpLoader(http, "./i18n/", ".json");

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),

    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: "top",
      })
    ),
    provideHttpClient(
      withInterceptors([
        loadingInterceptor,
        tokenInterceptor,
        errorInterceptor,
      ]),
      withInterceptorsFromDi()
    ),
    provideAnimations(),
    provideTranslateService({
      defaultLanguage: "en",
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),

    provideNgxMask(),
    provideAppInitializer(() => {
      const appInitializerService = inject(AppInitializerService);
      const lookupService = inject(LookupService);

      return appInitializerService.getCcToken().toPromise().then(() => {
        appInitializerService.getMerchantLookups();
        // appInitializerService.getPermissionsLookups();
        appInitializerService.getFreelancerLookups();

        lookupService.getProducts().subscribe({
          next: (res: any) => {
            localStorage.setItem("products", JSON.stringify(res));
          },
        });
      });
    }),
    MessageService,
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: false || "none",
          cssLayer: {
            name: "primeng",
            order: "tailwind-base, primeng, tailwind-utilities",
          },
        },
      },
    }),
  ],
};
